module.exports = __webpack_public_path__ + "media/video203.760df029.mp4";